<div class="list-view-accordion">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>
    <ng-container *ngFor="let item of reportingSetDefList">
        <div class="reporting-set-view" id="reporting-set-container">
            <cxone-checkbox type="checkbox" [labelText]="item.ReportingSetName" [value]="item._id" [(ngModel)]="checkboxes[item._id]"
                (clicked)="handleCheckBoxClicked(item._id, $event.target.checked)" [checkboxId]="item._id" [name]="item._id" [disabled]="item.disabled">
            </cxone-checkbox>
        </div>
    </ng-container>
</div>